import React, { lazy, Suspense } from 'react'; // --- 1. IMPORTAMOS lazy y Suspense ---
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import CircleLoader from "react-spinners/CircleLoader"; // Usaremos el spinner que ya tienes

// --- 2. CONVERTIMOS TODAS LAS PÁGINAS A IMPORTACIONES 'LAZY' ---
// En lugar de cargar todo al inicio, cada página se cargará solo cuando se necesite.

const Error404 = lazy(() => import('containers/errors/Error404'));
const Home = lazy(() => import('containers/pages/Home'));
const Cases = lazy(() => import('containers/pages/Cases'));
const Services = lazy(() => import('containers/pages/services/inspeccion/Services'));
const About = lazy(() => import('containers/pages/About'));
const Careers = lazy(() => import('containers/pages/Careers'));
const Blog = lazy(() => import('containers/pages/Blog'));
const Contact = lazy(() => import('containers/pages/contact/Contact'));
const Gracias = lazy(() => import('containers/pages/contact/Gracias'));
const Terms = lazy(() => import('containers/pages/contact/Terms'));
const Privacy = lazy(() => import('containers/pages/contact/Privacy'));
const Category = lazy(() => import('containers/pages/Category'));
const Search = lazy(() => import('containers/pages/Search'));
const PostDetail = lazy(() => import('containers/pages/PostDetail'));
const OptIn = lazy(() => import('containers/pages/OptIn'));
const OptInCTA = lazy(() => import('containers/pages/OptInCTA'));
const Ecommerce = lazy(() => import('containers/pages/cases/Ecommerce'));
const JavascriptDev = lazy(() => import('containers/pages/services/development/JavascriptDev'));
const Ingenieria = lazy(() => import('containers/pages/services/ingenieria/Ingenieria'));
const Ensayos = lazy(() => import('containers/pages/services/ensayos/Ensayos'));

// Componente de carga para el 'fallback' de Suspense
const LoadingFallback = () => (
    <div className="flex justify-center items-center h-screen">
        <CircleLoader color="#00529B" size={50} />
    </div>
);


function AnimatedRoutes() {
    const location = useLocation();

    return (
        <AnimatePresence>
            {/* --- 3. ENVOLVEMOS LAS RUTAS EN SUSPENSE --- */}
            {/* Le decimos a React qué mostrar mientras se descarga el código de la siguiente página */}
            <Suspense fallback={<LoadingFallback />}>
                <Routes location={location} key={location.pathname}>
                    {/* El resto de tus rutas se mantiene exactamente igual */}
                    <Route path="*" element={<Error404 />} />

                    {/* Home Display */}
                    <Route path="/" element={<Home />} />
                    {/* Ruta comentada restaurada */}
                    {/* <Route path="/casos" element={<Cases />} />
                    <Route path="/casos/ecommerce" element={<Ecommerce />} /> */}
                    <Route path="/servicios/inspeccion-de-izaje" element={<Services />} />
                    <Route path="/servicios/javascript" element={<JavascriptDev />} />
                    <Route path="/servicios/memorias-de-calculo" element={<Ingenieria />} />
                    <Route path="/servicios/ensayos" element={<Ensayos />} />
                    <Route path="/nosotros" element={<About />} />
                    <Route path="/carreras" element={<Careers />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<PostDetail />} />
                    <Route path="/s=:term" element={<Search />} />
                    <Route path="/category/:slug" element={<Category />} />
                    <Route path="/contacto" element={<Contact />} />
                    <Route path="/contacto/gracias" element={<Gracias />} />
                    <Route path="/contacto/terminos-servicios" element={<Terms />} />
                    <Route path="/contacto/politica-privacidad" element={<Privacy />} />
                    {/* <Route path="/ebook" element={<OptIn />} />
                    <Route path="/ebook/training" element={<OptInCTA />} /> */}
                </Routes>
            </Suspense>
        </AnimatePresence>
    );
}

export default AnimatedRoutes;

